<template>
<!-- <router-view /> -->
 <div class="d-flex" v-if="isSettingPath">
    <div  style="">
      <Sidebar />
    </div>
    <div class="flex-grow-1 bg-white">
      <router-view />
    </div>
  </div>

    <router-view v-else/>

</template>

<script>
import Sidebar from '@/components/Sidebar_Management_Component.vue'
export default {
  name: 'App',
  components: {
    Sidebar
  },
   computed: {
    isSettingPath() {
      return this.$route.path.startsWith('/management')
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'Kanit';
  src: url('../src/assets/fonts/Kanit/Kanit-Light.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Kanit-bold';
  src: url('../src/assets/fonts/Kanit/Kanit-SemiBold.ttf') format('truetype');
  font-weight: 400;
  font-style: bold;
}
@font-face {
  font-family: 'Kanit-regular';
  src: url('../src/assets/fonts/Kanit/Kanit-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: bold;
}




/* @import url('https://fonts.googleapis.com/css2?family=Allerta+Stencil&display=swap');
@font-face {
    font-family: Maehongson;
    src: url(../src/assets/front/Maehongson.ttf);
} */

/* div{
  font-family:  Maehongson;
}
h1{
  font-family:  Maehongson;
}

.allerta-stencil-regular {
  font-family: "Allerta Stencil", sans-serif;
  font-weight: 400;
  font-style: normal;
} */


#app {
    font-family: 'Kanit';
  /* font-family:  Maehongson; */
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
